// @ts-nocheck
import { uk, en, ru } from "vuetify/locale";

export default {
	defaultLocale: "en",
	locales: [
		{
			code: "en",
			iso: "en-US",
			name: "English",
			file: "en.json",
		},
		{
			code: "uk",
			countryCode: "ua", // Needed for correct flag icon
			iso: "uk-UA",
			name: "Українська",
			file: "uk.json",
		},
		{
			code: "ru",
			iso: "ru-RU",
			name: "Русский",
			file: "ru.json",
		},
	],
	messages: Object.fromEntries(
		Object.entries({ en, uk, ru }).map(([key, value]) => [
			key,
			{ $vuetify: value },
		])
	),
	detectBrowserLanguage: {
		useCookie: true,
		redirectOn: "root",
		cookieKey: "bnz_locale",
	},
	numberFormats: {
		"en-US": {
			currency: {
				style: "currency",
				currency: "USD",
			},
		},
	},
	pluralRules: {
		uk: function (choice, choicesLength) {
			const n = Math.abs(choice);
			if (choicesLength === 1) {
				return 0;
			}
			if (n % 10 === 1 && n % 100 !== 11) {
				return 0;
			}
			if (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)) {
				return 1;
			}
			return 2;
		},
	},
	langDir: "locales",
	restructureDir: false,
	compilation: {
		strictMessage: false,
	},
};
